import { SupportTicketMapper } from '../SupportTicketMapper.js';

class CancelSupportTicketMapper {
  static createModelFromResponse(response) {
    return {
      ...SupportTicketMapper.createModelFromResponse(response),
      shipmentReference: response.shipment_reference,
      reason: response.cancel.reason
    };
  }
}

export { CancelSupportTicketMapper };
//# sourceMappingURL=CancelSupportTicketMapper.js.map
